import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "./AuthContext";

const WorkspaceContext = createContext(null);
export const useWorkspace = () => useContext(WorkspaceContext);

export function WorkspaceProvider({ children }) {
  const { user } = useAuth();
  const [workspaces, setWorkspaces] = useState([]);
  const [current, setCurrent] = useState(null);

  const refresh = useCallback(async () => {
    if (!user) return;
    const { data } = await api.get("/workspaces");
    setWorkspaces(data);
    if (data.length > 0) {
      const savedId = localStorage.getItem("brandops_workspace");
      const found = data.find((w) => w.id === savedId);
      setCurrent(found || data[0]);
    } else {
      setCurrent(null);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const select = (ws) => {
    setCurrent(ws);
    if (ws) localStorage.setItem("brandops_workspace", ws.id);
  };

  return (
    <WorkspaceContext.Provider value={{ workspaces, current, select, refresh }}>
      {children}
    </WorkspaceContext.Provider>
  );
}
